import React from "react";
import OurServices from "../OurServices";

function Boom() {
  return (
    <div>
      <OurServices
        hero_title={"Boom Barrier System"}
        hero_desc={
          "Your trusted partner in innovative security and office automation solutions."
        }
        about_img_one={
          "https://res.cloudinary.com/ddffnw81j/image/upload/v1743236932/boom-2_og1sop.png"
        }
        about_img_one_desc={
          "A Boom Barrier System is an automated or manually controlled security gate used to regulate vehicle entry and exit in high-traffic or restricted areas. It consists of a horizontal bar (boom arm) that moves up and down to allow or restrict vehicle access."
        }
        about_img_two={
          "https://res.cloudinary.com/ddffnw81j/image/upload/v1743236932/boom-1_hpxilv.png"
        }
        about_img_two_desc={
          "A boom barrier operates using electromechanical or hydraulic mechanisms to control the movement of the boom arm. It can be activated through remote controls, RFID cards, license plate recognition (ANPR), or push-button systems."
        }
        why_desc={
          "Our boom barrier systems offer a seamless, automated approach to controlling vehicle entry and exit. Designed for durability, speed, and reliability, our solutions are ideal for a variety of applications including parking management and gate control for both residential and commercial sectors."
        }
        s_one={"Boom Barrier Installation"}
        s_two={"System Configuration & Integration"}
        s_three={"Ongoing Maintenance & Support"}
        s_four={"Upgrades and Customization"}
        f_one_title={"High-Speed Automation"}
        f_one_desc={
          "Our boom barrier systems feature high-speed automation, ensuring quick and seamless vehicle access without any delays."
        }
        f_two_title={"Durable & Long-Lasting"}
        f_two_desc={
          "Built to withstand harsh conditions, our boom barriers are crafted with high-quality materials for enhanced durability and long-term performance."
        }
        f_three_title={"Remote Control & Access"}
        f_three_desc={
          "With remote control access options, managing entry and exit becomes more convenient and efficient for both staff and users."
        }
        f_four_title={"Customizable Options"}
        f_four_desc={
          "Our boom barriers are highly customizable, allowing you to integrate them with your existing security systems, such as card readers, license plate recognition, or gate systems."
        }
        c_one_title={"Serving a Wide Range of Clients"}
        c_one_desc={
          "We have helped numerous clients across different sectors, from residential complexes to commercial and industrial properties, in automating their vehicle access control using boom barriers."
        }
        c_two_title={"Secure Your Premises with Vitri Enterprises Today!"}
        c_two_desc={
          "Enhance the security and efficiency of your property with our advanced boom barrier systems. Contact us now to learn more and get started on your project."
        }
      />
    </div>
  );
}

export default Boom;
